import get from 'lodash.get';

const getQuoteAmount = quote => get(quote, 'totalAmount.amount') || 0;

export const lowestQuoteReduce = (prevQuote, currentQuote) =>
    getQuoteAmount(prevQuote) < getQuoteAmount(currentQuote) ? prevQuote : currentQuote;

export const getQuoteAmountByCurrency = (quote, currency) => {
    const amountObj = get(quote, 'totalAmount.convertedAmountList', []).find(
        convertedAmount => convertedAmount.currency === currency
    );
    return amountObj ? amountObj.amount : null;
};
